import React from 'react';
import { Crown, ArrowRight, TrendingUp, Users, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function LeadershipPage() {
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-1022" data-mp="1qjiz2l95jka1">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-8 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-1023" data-mp="1zlih9gvwkuek">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-1024" data-mp="2eaofp2mx2gle" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-1025" data-mp="29b21apvcqub0">
          <div className="inline-block px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-6" data-id="element-1026" data-mp="sxlp5c8u8n9p">
            Executive Recruiting
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-1027" data-mp="3cmo8qbnew3gb">
            HIRE Leadership
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-1028" data-mp="3hlr4t6leyzc5">
            For companies that need to recruit leadership-level talent to scale
            their D2D and home services operation.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-1029" data-mp="3vcnuopnyh2fi">
            Finding managers and team leaders requires a different approach. We
            build and run targeted campaigns to attract the leaders who will
            drive your team's growth.
          </p>
        </motion.div>
      </section>

      {/* 2. PRICING */}
      <section className="pt-4 pb-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-1030" data-mp="e3r3ube9zu81">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1031" data-mp="2axu78mfkxzzw">
          {/* Build Fee */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-1032" data-mp="2fwx59mx575yd">
            <div className="mb-4" data-id="element-1033" data-mp="27vz7fj8vn4q8">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-1034" data-mp="27xaebrxmcslk">
                Implementation (One-Time)
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-1035" data-mp="2htnd3480twn6">$1,000*</div>
              <p className="mt-2 text-xs text-slate-500" data-id="element-1036" data-mp="2cuk9zpblq0hu">
                *Must be built in conjunction with a standard campaign.
              </p>
              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-1037" data-mp="2qsh7qp1skcy3">
                {['Leadership opportunity and company profiling', 'Custom ATS with dashboards, workflows, and job board integrations', 'Culture video and leadership-focused ad copywriting', 'Landing pages and executive application flows', 'Targeted campaign design built to reach experienced operators', 'Compensation and role benchmarking by region', 'Pre-launch system stress test', 'Covers implementation of standard and leadership campaign'].map((point, i) => <li key={i} className="flex items-start" data-id="element-1038" data-mp="3t5jywgapumyj" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-1039" data-mp="3f7dd3yj1kdf8" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-1040" data-mp="3k55a36yjmpqa">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Monthly Total */}
          <div className="bg-slate-900/40 border border-[#7FE0C3]/30 p-6 rounded-xl relative" data-id="element-1041" data-mp="3a9k6x5hqnjey">
            <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-xl" data-id="element-1042" data-mp="2wdzmu6q9wv5y" />
            <div className="mb-4" data-id="element-1043" data-mp="30hxn4krc4c0l">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-1044" data-mp="2mi6d0v3xvfrv">
                Total Monthly
              </div>
              <div className="text-4xl font-bold text-white mb-1" data-id="element-1045" data-mp="2rfy45mwrexv0">
                Same as standard
              </div>
              <div className="text-sm text-slate-500 mb-6" data-id="element-1046" data-mp="3ttvwdk6w1gib">
                / month, on the standard campaign structure
              </div>

              <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-1047" data-mp="3l1u1s2ji2ufy">
                <div className="flex justify-between text-sm" data-id="element-1048" data-mp="3kzziesnvnadz">
                  <span className="text-slate-400" data-id="element-1049" data-mp="3g27ndprxr85k">Partnership</span>
                  <span className="text-white font-medium" data-id="element-1050" data-mp="3b4flq41ho7o6">$1,500</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-1051" data-mp="3652yhi6pgyl2">
                  <span className="text-slate-400" data-id="element-1052" data-mp="366xld21jf0rs">Pipeline Management</span>
                  <span className="text-white font-medium" data-id="element-1053" data-mp="323rj05hjptql">
                    $1,000 per $2,500 of ad spend
                  </span>
                </div>
              </div>

              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-1054" data-mp="10c4p9w69rkqf">
                {['Active ad management and real-time optimization', 'Targeted outreach to experienced operators and team leaders', 'Interview execution handled for you', 'Vetted candidates passed to you for final approval only', 'Monthly recruiting review and ongoing consulting'].map((point, i) => <li key={i} className="flex items-start" data-id="element-1055" data-mp="1hlgppk2c6nb6" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-1056" data-mp="1hn04f68cgqau" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-1057" data-mp="jzje86mdji8q">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Performance Pricing */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-1058" data-mp="xy9c3oh0ply5">
            <div className="mb-4" data-id="element-1059" data-mp="25bjdvp34r94i">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-4" data-id="element-1060" data-mp="25ai1nhadogl7">
                Performance Pricing
              </div>
              <div className="text-white text-sm font-medium mb-1" data-id="element-1061" data-mp="a7cyidmw9zpf">
                Leader retention bonus
              </div>
              <div className="flex items-baseline mb-2" data-id="element-1062" data-mp="57guiee7689v">
                <span className="text-3xl font-bold text-white" data-id="element-1063" data-mp="j8b593opwlbp">$2,500</span>
                <span className="text-slate-400 ml-2 text-sm" data-id="element-1064" data-mp="j7i3yi8j2o0y">/ month</span>
              </div>
              <p className="text-sm text-slate-400 mb-4" data-id="element-1065" data-mp="e9ztuoiry2rd">
                Starting at day 30 active, capped at 6 payments
              </p>
              <div className="bg-slate-900/60 border border-slate-700/50 rounded-lg p-3" data-id="element-1066" data-mp="3inom6k5ff9t6">
                <p className="text-xs text-slate-400 flex items-start leading-relaxed" data-id="element-1067" data-mp="9fc7voliczg">
                  <ArrowRight className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-1068" data-mp="ba11l2zmp8t" />
                  <span data-id="element-1069" data-mp="3rm9zo0w1jyn3">
                    Starts at day 30 and is billed only for the months the
                    leader{' '}
                    <strong className="text-slate-200" data-id="element-1070" data-mp="2yzz26z3qedui">
                      stays in the role
                    </strong>
                    , capped at 6 payments.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-1071" data-mp="15goysjnkwybi">
          <p className="text-[#7FE0C3] text-center font-medium" data-id="element-1072" data-mp="1afjqyc7frz8a">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 3. WHO LEADERSHIP IS FOR */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto border-t border-slate-800/50" data-id="element-1073" data-mp="226fs4fk4wffq">
        <div className="text-center mb-12" data-id="element-1074" data-mp="1o6oiss4kbn82">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-1075" data-mp="1t6av8zckgzft">
            Why Leadership Recruiting Is Different
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-1076" data-mp="crrq98966fvy">
            Recruiting managers and team leaders requires a different approach
            than recruiting reps.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1077" data-mp="19fqkf8ggf47d">
          <div className="space-y-4 text-slate-400" data-id="element-1078" data-mp="14f2y30367bjh">
            <p data-id="element-1079" data-mp="14eb39rhedhu9">
              Leadership-level talent doesn't respond to mass recruiting
              funnels. They aren't looking, so they need to be found.
            </p>
            <p data-id="element-1080" data-mp="uiq37yvw2rn5">
              We build dedicated campaigns designed to attract operators who can
              run teams, drive culture, and own production at scale.
            </p>
            <p data-id="element-1081" data-mp="1n5u2dn8awbr0">
              Because the impact of one strong leader compounds, the pricing is
              aligned to outcomes, not activity.
            </p>
          </div>
          <div className="bg-slate-900/40 border border-[#7FE0C3]/20 rounded-xl p-8 space-y-6" data-id="element-1082" data-mp="1dgk8c1twcj09">
            <div className="flex items-start" data-id="element-1083" data-mp="2avemwak3rh2e">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-1084" data-mp="2ax987pzadb70">
                <Users className="w-6 h-6 text-[#7FE0C3]" data-id="element-1085" data-mp="2edvkp3w9kys0" />
              </div>
              <div data-id="element-1086" data-mp="2efykugr4s8ag">
                <h3 className="text-white font-bold mb-2" data-id="element-1087" data-mp="2iexm9rdnlmx5">
                  Interviews Handled
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-1088" data-mp="2ne0svg9a8178">
                  We run the interview process and only pass candidates to you
                  for final approval, so leadership time stays focused on
                  production.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1089" data-mp="31djsfko1247x">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-1090" data-mp="31c8onkul0wgt">
                <TrendingUp className="w-6 h-6 text-[#7FE0C3]" data-id="element-1091" data-mp="3b4ef2q56r5tw" />
              </div>
              <div data-id="element-1092" data-mp="3g37syjodwyul">
                <h3 className="text-white font-bold mb-2" data-id="element-1093" data-mp="3g3r0d6ges4ud">
                  Performance Aligned
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-1094" data-mp="3l2u6ku84kh3x">
                  You only pay more when the leader's team actually produces.
                  Performance pricing kicks in at production milestones, not at
                  hire.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1095" data-mp="1emvlz92d7thx">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-1096" data-mp="1em3v2bjpqjxz">
                <Crown className="w-6 h-6 text-[#7FE0C3]" data-id="element-1097" data-mp="1ocyez99hl7g9" />
              </div>
              <div data-id="element-1098" data-mp="1tc1lky547lqc">
                <h3 className="text-white font-bold mb-2" data-id="element-1099" data-mp="1tbi1pbvwmn9o">Targeted Outreach</h3>
                <p className="text-slate-400 text-sm" data-id="element-1100" data-mp="1xe6bpmwcu088">
                  Campaigns are built to attract experienced operators, not
                  generic applicants.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. CTA */}
      <section className="py-32 px-6 md:px-12 text-center border-t border-slate-800/50" data-id="element-1101" data-mp="7yyjcahoc3yt">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-1102" data-mp="fp9yh96459r">
          Ready to recruit leaders who scale your team?
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-[#7FE0C3] hover:bg-[#5ACCA8] text-[#163A5F] font-bold rounded-lg transition-all transform hover:scale-105" data-id="element-1103" data-mp="3rtv16ma26yoi">
          Discuss Leadership
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-1104" data-mp="3hy1ql8fwhf9d" />
        </button>
      </section>
    </div>;
}